/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Reason_Anywhere_TitleInputs */



/**
* | output |
* | --- |
* | "Wherever the vessel is" |
*
* @param {Home_Reason_Anywhere_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_reason_anywhere_title = /** @type {((inputs?: Home_Reason_Anywhere_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Reason_Anywhere_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("船在哪里，我们就在哪里")
	return /** @type {LocalizedString} */ ("Wherever the vessel is")
});